import { Icons } from "src/library/components/Icon/types";
import {
  ERPSeedless,
  ERPRJL
} from "src/utils/constants";

import AccountingPage from "../Admin/Accounting/AccountingPage";
import { IRoute } from "../Router/routes";
import Dashboard from "./Dashboard";
import ListsPage from "./Lists/ListsPage";
import OrdersPage from "./Orders/OrdersPage";
import ProductsPage from "./Products/ProductsPage";
import WasteOverviewPage from "./Waste/WasteOverviewPage";

const CustomerMain: IRoute[] = [
  {
    exact: true,
    path: "/dashboard",
    title: "Dashboard",
    icon: Icons.CALENDAR,
    pageComponent: Dashboard,
    menuType: "MAIN",
    privateRoute: true,
    roles: [ "customer" ],
    canView: store => {
      const currentUserRole = store.global.role;

      if (!currentUserRole) {
        return false;
      }

      if (currentUserRole.code === "customer-admin") {
        return false;
      }

      return true;
    }
  },
  {
    exact: true,
    path: "/products",
    title: "%PRODUCTS%",
    icon: Icons.PRODUCT,
    contextMenu: {
      ORDER_PRODUCT_SELECTION: {
        title: "Browse %PRODUCTS%",
        icon: Icons.PRODUCT
      },
      LIST_PRODUCT_SELECTION: {
        title: "Browse %PRODUCTS%",
        icon: Icons.PRODUCT
      }
    },
    pageComponent: ProductsPage,
    menuType: "MAIN",
    allowedContexts: [ "ORDER_PRODUCT_SELECTION", "LIST_PRODUCT_SELECTION" ],
    privateRoute: true,
    roles: [ "customer" ]
  },
  {
    exact: true,
    path: "/products",
    title: "%PRODUCTS%",
    icon: Icons.PRODUCT,
    contextMenu: {
      ORDER_PRODUCT_SELECTION: {
        title: "Browse %PRODUCTS%",
        icon: Icons.PRODUCT,
        hidden: false
      },
      LIST_PRODUCT_SELECTION: {
        title: "Browse %PRODUCTS%",
        icon: Icons.PRODUCT,
        hidden: false
      }
    },
    pageComponent: ProductsPage,
    menuType: "ADMIN_MAIN",
    allowedContexts: [ "ORDER_PRODUCT_SELECTION", "LIST_PRODUCT_SELECTION" ],
    privateRoute: true,
    roles: [ "admin" ],
    hidden: true
  },
  {
    exact: true,
    path: "/orders",
    title: "%ORDERS%",
    icon: Icons.CART,
    pageComponent: OrdersPage,
    menuType: "MAIN",
    privateRoute: true,
    permissions: [ "view-order" ],
    roles: [ "customer" ]
  },

  {
    exact: true,
    path: "/lists",
    title: "%LISTS%",
    icon: Icons.TABLE,
    pageComponent: ListsPage,
    menuType: "MAIN",
    privateRoute: true,
    permissions: [ "view-list" ],
    roles: [ "customer" ]
  },
  // Main customer accounting routes
  {
    exact: true,
    path: "/accounting",
    pageComponent: AccountingPage,
    title: "Accounting",
    icon: Icons.CURRENCYPOUND,
    menuType: "MAIN",
    privateRoute: true,
    modules: [ "accounting" ],
    roles: [ "customer" ],
    canView: store => {
      return !!store.users.user?.role?.permissions.find(p => p.code === "view-invoice") || !!store.global.masqueradeMode?.active;
    }
  },
  {
    exact: true,
    path: "/waste",
    title: "Waste Management",
    icon: Icons.WASTE,
    pageComponent: WasteOverviewPage,
    menuType: "MAIN",
    privateRoute: true,
    permissions: [ "view-waste" ],
    roles: [ "customer" ],
    erp: [ ERPSeedless, ERPRJL ],
    modules: [ "waste" ],
    canView: store => {
      // only show the waste page if this drop allows it
      const drop = store.drops.drop;

      if (!drop) {
        return false;
      }

      if (drop.groupedSettings[ "allow_waste_recording" ]?.value.allowed) {
        return true;
      }

      return false;
    }
  }
];

export default CustomerMain;
